import React from 'react'
import PropTypes from 'prop-types'

import styles from 'containers/common/formContainer/FormContainer.module.scss'
import { ReactComponent as CheckListIcon } from 'assets/icons/checklist.svg'

export const FormContainer = ({ children }) => (
  <div className={styles.formContainer}>
    <div className={styles.iconContainer}>
      <CheckListIcon />
    </div>
    {children}
  </div>
)

FormContainer.propTypes = {
  children: PropTypes.any,
}
